<template>
  <div>
    <el-dialog
      v-if="dialogVisible"
      :title="title"
      :visible.sync="dialogVisible"
      width="1300px"
      :before-close="handleClose"
    >
      <el-row :gutter="20">
        <el-col :span="12"
          ><LeftSku ref="LeftSku" :height="height" :disabled="disabled" @search="onSearch"></LeftSku
        ></el-col>
        <el-col :span="12"
          ><RightDeliveryWarehouse
            ref="RightDeliveryWarehouse"
            :height="height"
          ></RightDeliveryWarehouse
        ></el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="confirm">下一步</el-button>
      </span>
    </el-dialog>

    <AppointLogistics
      ref="AppointLogistics"
      show-last-btn
      @confirm="getLogisticsData"
    ></AppointLogistics>
  </div>
</template>

<script>
import LeftSku from './LeftSku.vue';
import RightDeliveryWarehouse from './RightDeliveryWarehouse.vue';
import AppointLogistics from '../AppointLogistics.vue';
import { randomID } from '@/utils/index';
export default {
  name: 'BusinessOrderSourceAppointDeliveryParcel',
  components: { LeftSku, RightDeliveryWarehouse, AppointLogistics },
  props: {
    disabled: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  inject: ['packageData'],
  data() {
    return {
      dialogVisible: false,
      title: '',
      isEdit: false,
      height: null,
      data: {},
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.$nextTick(() => {
          this.height = (document.documentElement.clientHeight - 12) / 2;
        });
      }
    },
  },
  methods: {
    show(info) {
      this.data = info || {};
      this.isEdit = !!info;
      this.title = this.isEdit ? '编辑包裹' : '添加包裹';
      this.dialogVisible = true;
      // 重置组件
      this.$nextTick(() => {
        this.$refs.RightDeliveryWarehouse.reset();
        this.$refs.LeftSku.reset((info && info.goodsList) || []);
        if (this.isEdit) {
          this.$refs.RightDeliveryWarehouse.getData(info.tagList);
          this.$refs.RightDeliveryWarehouse.radio = info.stockWarehouseCode;
          this.$refs.RightDeliveryWarehouse.selectedData = {
            stockId: info.stockWarehouseId,
            stockNo: info.stockWarehouseCode,
            stockName: info.stockWarehouseName,
          };
        }
      });
    },
    hide() {
      this.$refs.LeftSku.reset();
      this.$refs.RightDeliveryWarehouse.reset();
      this.dialogVisible = false;
    },
    onSearch(data) {
      data = data.map(e => {
        const { number, skuCode, skuName } = e;
        return {
          number,
          skuCode,
          skuName,
        };
      });
      this.$refs.RightDeliveryWarehouse.getData(data);
    },
    handleClose() {
      this.hide();
    },
    getLogisticsData(data) {
      // 获取发货仓数据
      const { stockName, stockNo, stockId } = this.$refs.RightDeliveryWarehouse.selectedData;

      const res = {
        ...data,
        BJ_EBC_ID: this.data.BJ_EBC_ID || randomID(),
        tagList: this.$refs.LeftSku.tagList,
        goodsList: this.$refs.LeftSku.pagesSelectedRows,
        goodsNum: this.$refs.LeftSku.goodsNum,
        stockWarehouseId: stockId,
        stockWarehouseCode: stockNo,
        stockWarehouseName: stockName,
      };
      this.msgSuccess(this.$t('toast.operationSuccessText'));
      this.$emit('confirm', res);
      this.hide();
    },
    confirm() {
      if (!this.$refs.LeftSku.tagList.length) {
        this.$message.warning('请选择包裹商品');
        return;
      }
      if (this.$refs.RightDeliveryWarehouse.radio === '') {
        this.$message.warning('请选择指定发货仓');
        return;
      }
      const data = {
        tagList: this.$refs.LeftSku.tagList,
        ...this.$refs.RightDeliveryWarehouse.selectedData,
        ...this.data,
      };
      this.$refs.AppointLogistics.show(data);
      // this.$emit('confirm', data);
      // this.hide();
    },
  },
};
</script>

<style></style>
